import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import estateImg from '../../assets/tool-icon-estate-planning.png';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .bgW': {
        width: '285px',
        backgroundColor: '#fff',
    },
    '& .tableTool': {
        padding: '16px',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
        '& .searchWapper': {
            border: '1px solid #CCCCCC',
            borderRadius: '3px',
            width: '285px',
            height: '38px',
            '& .search': {
                height: '32px',
                color: '#58727C',
                padding: '0 10px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            border: '1px solid #CCCCCC',
        },
    },
    '& .tableWapper': {
        width: '100%',
        overflowX: 'auto',
        '& .table': {
            minWidth: '650px',
        }
    },
    '& .basic-status': {
        width: '110px',
        height: '26px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '50px',
        backgroundColor: 'gray'
    },
    '& .color-1': {
        backgroundColor: '#F7B500'
    },
    '& .color-2': {
        backgroundColor: '#18C6FF'
    },
    '& .color-3': {
        backgroundColor: 'gray'
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .btn': {
        width: '186px',
    },
    '& .m-20': {
        margin: '0 20px',
    },
});